import { createFileRoute } from '@tanstack/react-router'

import { ChatThread, Composer } from '@/components/shared'
import { AppLink as Link } from '@/components/shell'
import { PipelineChip } from '@/components/spravce/shared'
import { DEFAULT_THREAD, THREADS } from '@/mocks/spravce/chatVlakno'

export const Route = createFileRoute('/spravce/chaty/$client')({
  head: () => ({ meta: [{ title: 'Chat · Aplikace Bitez' }] }),
  component: SpravceChatThread,
})

/**
 * Bára's thread — with a venue, or with one of her photographers (open-items
 * B12). One screen for both, because from her side they are the same job:
 * somebody is waiting for an answer.
 *
 * It is the **same conversation** the client sees, so it is the same
 * `ChatThread` and the same `Composer`. What differs is what a professional
 * needs around it: the client's chat is a floating island with one face,
 * because they only ever talk to Bára; hers has to say **which** of six clients
 * this is, **why** the thread matters right now (the pipeline chip her inbox
 * already showed), and offer one tap to everything else about them.
 *
 * The avatar stays round even for a venue: the app draws places as squares, but
 * in a conversation the other end is someone you are talking to.
 */
function SpravceChatThread() {
  const { client } = Route.useParams()
  const thread = THREADS[client] ?? THREADS[DEFAULT_THREAD]

  return (
    <div className="flex min-h-full flex-col px-4">
      {/* The client's island, mirrored: same pill, same size. Tapping it opens
          everything else about them, so it needs no arrow — the whole pill is
          the door. The context she triaged on rides underneath as a second pill
          instead of crowding the first. */}
      <div className="sticky top-2 z-10 flex flex-col items-center gap-2 pt-2">
        <Link
          href={thread.party.detailHref}
          className="flex max-w-full items-center gap-2 rounded-full bg-white py-1.5 pr-3.5 pl-1.5 shadow-lg ring-1 ring-ink/5"
        >
          <img
            src={thread.party.avatar}
            alt=""
            width={120}
            height={120}
            className="size-7 shrink-0 rounded-full object-cover"
          />
          <span className="min-w-0">
            <span className="font-display block truncate text-sm leading-none uppercase">
              {thread.party.title}
            </span>
            <span className="mt-0.5 block truncate text-[9px] leading-none font-semibold text-ink/45">
              {thread.party.subtitle}
            </span>
          </span>
        </Link>

        <PipelineChip {...thread.chip} />
      </div>

      <ChatThread entries={thread.entries} avatar={thread.party.avatar} />

      <Composer suggestions={thread.replies} placeholder="Napište zprávu…" />
    </div>
  )
}
